import { createFileRoute } from "@tanstack/react-router";

import { AdminShell } from "@/components/admin/AdminShell";
import { CustomerTransactionsPage } from "@/components/admin/customers/CustomerTransactionsPage";
import { requireAdmin } from "@/lib/require-admin";

export const Route = createFileRoute("/admin_/customers_/$id/transactions")({
  beforeLoad: () => {
    requireAdmin();
  },
  component: CustomerTransactionsRoute,
});

function CustomerTransactionsRoute() {
  const { id } = Route.useParams();
  return (
    <AdminShell page="customers">
      <CustomerTransactionsPage id={id} />
    </AdminShell>
  );
}
